// src/components/TickerBar.js
import React from "react";

export default function TickerBar() {
  const message = "Welcome to the Turner Place Smart Bin • Sorting Smarter for a Greener Tomorrow •";

  return (
    <div className="w-full bg-black text-white overflow-hidden whitespace-nowrap">
      <div className="flex animate-marquee">
        <span className="px-8">{message}</span>
        <span className="px-8">{message}</span>
        <span className="px-8">{message}</span>
        <span className="px-8">{message}</span>
      </div>
    </div>
  );
}
